import { countryData } from "@/data/country-data"

export interface CheckoutAddressLines {
    address1: string
    apartmentHouseNumber?: string
    zipCode: string
    city: string
    state?: string
    country: string
}

/** Centra and Loqate both need the apartment on the same line as the street. */
export const mergeAddressLine = (address: CheckoutAddressLines): string | null =>
    address.apartmentHouseNumber
        ? `${address.address1} ${address.apartmentHouseNumber}`
        : address.address1 || null

/** Street and apartment on separate lines, then zip/city, then the country name. */
export const formatAddressForDisplay = (address: CheckoutAddressLines): string[] =>
    [
        address.address1,
        address.apartmentHouseNumber,
        [address.zipCode, address.city, address.state].filter(Boolean).join(" "),
        countryData.find(entry => entry.alpha2Code === address.country)?.countryName ??
            address.country
    ].filter((line): line is string => Boolean(line))
